import { useTranslation } from 'react-i18next'

const RelativeEnd = (props) => {
  const { t } = useTranslation()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="relative-end-title"
      {...props}
    >
      <title id="relative-end-title">{t('antagonists:relative:components:end')}</title>
      <path
        d="M1613.56 241.27c-7.04 2.66-46.55 6-52.68 22.3-6.13 16.29 1.37 24.25.58 38.82s7.79 25.45 8.15 34.8c.34 9.33 15.36 28.16 15.36 28.16l108.45-17.71s-.68-25.53-.64-38.26c.05-12.75 4.06-23.45-2.86-34.1-6.93-10.65-11.04-15.97-20.04-25.61-8.99-9.64-21.14-22.48-34.47-20.65-13.32 1.83-14.8 9.59-21.86 12.25h.02Z"
        style={{
          fill: '#afb1b4',
        }}
      />
      <path
        d="M1627.57 283.36c-12.66 3.31-19.12 12-31.69 14.77-12.55 2.78-22.3 10.46-19.11 19.73 3.19 9.27 11.74 35.32 7.03 37.7s-10.98-21.88-17.29-19.37c-6.31 2.5-3.44 12.94.45 25.36s7.77 25.65 12.14 24.69 7.59-5.26 7.59-5.26 2.64 26.96 11.94 35.42c9.3 8.46 23.17 19.92 36.09 21.49 12.94 1.57 15.36-3.89 25.11-9.52 9.59-5.55 20.48-18.22 24.89-31.75 3.36-10.28-.5-30.02 2.55-31.81 3.05-1.77 7.48 2.77 10.99-4.65s4.62-15.41 5.4-22.23c.78-6.81 2.01-22.03-4.35-22.3-6.34-.25-12.28 14.35-12.67 17.76s-3.2 6.25-4.68 2.15c-1.48-4.1.9-14.04-3.45-20.82-4.35-6.78-5.57-7.07-7.15-19.45-1.59-12.38-18.74-9.69-26.06-9.17s-5.07-6.05-17.74-2.74h.02Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="m1637.52 329.71-.22 5.15s13.46-5.32 22.76-2.75c9.3 2.58 12.75 2.41 12.75 2.41l1.48-4.62s-9.44-6.5-19.39-6.65-17.37 6.47-17.37 6.47h-.02ZM1619.09 337.95l.47-4.15s-3.47-7.49-16.42-4.59c-12.19 2.74-17.71 7.73-17.71 7.73l2.77 3.89s12.42-3.64 16.95-3.67c5.4-.03 13.95.81 13.95.81v-.02Z"
        style={{
          fill: '#afb1b4',
        }}
      />
      <path
        d="M1592.73 360.54s11.68 49.27 3.05 63.2c-8.63 13.92-62.05 20.34-62.05 20.34s-14.58 56.59-14.4 58.94c1.68 21.11 240.13 265.62 235.07 12.53-.05-2.39-8.78-62.49-8.78-62.49s-49.22-19.47-59.78-29.2c-10.56-9.75-2.44-37.8-2.44-46.61V354.5l-90.66 6.03Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1626.01 396.14s1.09 3.75 1.85 6.08c.78 2.32 3.19 6.28 3.19 6.28l7.96-2.5s.36-3.08.11-6.51-1.71-6.61-1.71-6.61l-11.4 3.27Z"
        style={{
          fill: 'none',
        }}
      />
      <path
        d="M1622.19 407.51c1.57 2.61 2.01 2.36 4.28 4.59 2.25 2.22 4.2 5.24 10.53 4.09 6.33-1.15 10.73-8.04 12.84-7.77 2.11.28 2.55-.31 2.35-2.49s-8.54-9.73-12.1-8.46-3.67 3.28-4.59 3.48-1.91-1.97-5.66-1.46c-7.34.98-9.34 5.19-7.63 8.02h-.02Z"
        style={{
          fill: '#f2974a',
        }}
      />
      <path
        d="M1604.29 349.56c-2.97-.17-5.18 1.73-5.24 4.65-.05 2.92 1.79 4.21 4.45 4.54 3.14.37 5.05-1.43 5.41-4.45.25-2.11-1.55-4.59-4.62-4.76v.02Z"
        style={{
          fill: '#6b5738',
        }}
      />
      <path
        style={{
          fill: '#6b5738',
        }}
        d="m1597.16 354.24 14.1-6.34-1.37-5.03-14.57 7.87 1.84 3.5zM1651.98 343.92c2.94-.51 5.35 1.12 5.74 4.03s-1.29 4.4-3.89 5.02c-3.08.73-5.18-.84-5.88-3.79-.5-2.08 1.01-4.73 4.04-5.26h-.02Z"
      />
      <path
        style={{
          fill: '#6b5738',
        }}
        d="m1661.51 345.97-14.32-1.31-.09-5.33 15.14 2.69-.73 3.95z"
      />
      <path
        d="M1512.33 844.69s-4.43 172.36-.59 224.62c3.84 52.24 14.3 84.24 13.45 103.41-.86 19.17 1.26 149.68 2.36 176.25 1.1 26.57.11 82.34.11 82.34s19.48 9.17 39.27 5.85c19.79-3.33 36.93-10.7 36.93-10.7s6.62-20.24 4.1-40.94 9.5-71.1 4.9-101.68c-4.6-30.58 1.2-90.72 5.27-112.52 4.07-21.8 10.39-109.39 17.09-147.94 6.7-38.54 20.82-132.4 20.82-132.4l-8.82-57.74-134.91 11.46h.02Z"
        style={{
          fill: '#535b81',
        }}
      />
      <path
        d="M1624.13 849.61s32.96 172.92 30.36 242.86c-2.6 69.93-.75 76-.53 89.4.22 13.4-8.58 140.35-6.13 171.54 2.46 31.2 2.55 76.35 2.55 76.35s12.94 3.92 30.89 7.56c17.97 3.64 36.93-1.82 36.93-1.82s9.67-19.84 9.45-79.23c-.22-59.38 5.97-162.37 7.2-181.46 1.24-19.09-1.97-20.27 3.47-47.27 5.44-26.99 34-120.85 37.3-166.47 3.3-45.62-9.39-143.97-9.39-143.97l-142.12 32.53.02-.02Z"
        style={{
          fill: '#535b81',
        }}
      />
      <path
        d="M1648.51 951.46s1.01.16 2.61.25"
        style={{
          fill: 'none',
          stroke: '#d4c27f',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeWidth: '1.35px',
        }}
      />
      <path
        d="M1659.08 951.27c3-.56 6.06-1.69 8.36-3.84"
        style={{
          fill: 'none',
          stroke: '#d4c27f',
          strokeDasharray: '0 0 0 0 0 0 3.43 5.14',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeWidth: '1.35px',
        }}
      />
      <path
        d="M1669.84 944.23c.25-.51.48-1.04.67-1.63 3.82-11.74 1.91-68.25 1.91-68.25v-5.83"
        style={{
          fill: 'none',
          stroke: '#d4c27f',
          strokeDasharray: '0 0 0 0 0 0 0 0 0 0 3.43 5.14',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeWidth: '1.35px',
        }}
      />
      <path
        style={{
          fill: 'none',
          stroke: '#d4c27f',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeWidth: '1.35px',
        }}
        d="M1672.42 864.52v-2.63"
      />
      <path
        d="M1589.79 428.12s-5.35 10.93 11.8 22.75c17.16 11.82 27.35 9.67 25.73 9.13s10.49 56.55 10.49 56.55l12.56-55.47s18.6 1.34 30.44-16.06c8.35-12.25 5.01-21.16 5.01-21.16s22.59 9.28 46.72 19.5c24.13 10.2 58.77 12.73 61.97 25.08 3.22 12.34-36.89 113.48-32.08 146.24 4.82 32.76 1.07 83.77 3.22 106.86 2.15 23.09 10.73 136.94 10.73 136.94s-31.58 15.02-61.06 24.15c-29.49 9.13-48.32 31.7-48.32 31.7s-22.53-59.61-22.53-57.99-6.44 64.97-6.44 64.97-35.93 9.67-85.79-18.8c-49.86-28.47-62.42-41.76-62.42-41.76s23.8-81.77 27.57-127.94c3.75-46.18 4.82-132.11-5.89-164.32-10.73-32.21-33.07-95.57-15.92-107.92 17.16-12.34 42.03-16.42 55.13-20.46 17.07-5.26 39.07-11.97 39.07-11.97Z"
        style={{
          fill: '#e6f1e2',
        }}
      />
      <path
        d="M1753.58 462.27c-30.74 20.52-10.01 106-.36 142.53 9.66 36.52 27.66 78.75 41.06 86.8 13.4 8.05 62.74 7.43 65.95-15.13 3.22-22.56-26.48-63.95-33.99-107.45-7.51-43.5-23.51-92.94-33.15-103.69-9.66-10.74-28.27-10.59-39.52-3.06Z"
        style={{
          fill: '#e6f1e2',
        }}
      />
      <path
        d="M1765.18 827.79s-4.48 4.8-9.95 8.19-19.11 11.38-25.79 18.84c-6.69 7.46-32.91 33.23-32.91 33.23s2.05 9.27 12.34 5.41c10.29-3.86 18.52-11.07 18.52-11.07s4.88 13.65 21.61 16.74c16.71 3.09 28.3-1.29 28.3-1.29s7.46-9.8 12.34-20.6c4.88-10.82 13.64-34 13.64-34l-38.06-15.45h-.03Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1524.69 448.27c-40.36-.87-62.18 40.52-77.24 78.25-12.8 32.04-33.52 54.6-48.59 83.52s.81 85.85 26.71 79.46c25.9-6.39 111.6-89.42 111.6-89.42l-12.48-151.82ZM1789.67 670.78s-7.54 68.97-13.2 96.85-17.46 65.19-17.46 65.19 17.46 2.83 31.13 9.92c13.68 7.09 9.31 14.83 9.31 14.83l18.52-43.18s13.68-.95 18.87-26.45c5.19-25.51 23.12-78.42 23.12-90.22s3.3-26.93-6.61-38.26-60.85-14.16-63.68 11.33v-.02Z"
        style={{
          fill: '#e6f1e2',
        }}
      />
      <path
        d="M1486.43 502.98s24.66-27.19 31.36-35.64c6.69-8.46 24.72-33.99 28.67-37.08 3.95-3.09 55.4-26.15 55.4-26.15s4.18 3.17-.9 9.92-30.85 16.42-30.85 16.42 15.33-.06 18.33 1.77c3 1.83 3.76 10.65 2.04 12.84s-2.19 3.31-2.19 3.31 3.16 2.22 2.91 8.1c-.26 5.88-3.82 5.33-3.82 5.33s6.34 4.9 1.66 10.73c-4.7 5.83-16.57 7.7-16.57 7.7s-9.69 10.11-23.18 17.49c-13.5 7.39-17.27 7.07-18.98 10.79-1.73 3.73-25.64 19.03-25.64 19.03s-17.88-24.53-18.21-24.55l-.02-.02Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1498.4 483.13s9.42 14.06 18.27 22.09c8.85 8.04 16.34 18.05 16.34 18.05s-14.68 50.19-36.82 87.61c-22.12 37.42-69.96 88.51-85.51 77.8-15.55-10.73-30.83-47.33-12.83-78.42s39.48-68.88 61.02-86.38c21.55-17.51 39.49-40.75 39.49-40.75h.03Z"
        style={{
          fill: '#e6f1e2',
        }}
      />
      <path
        d="M1686.26 333.2c-1.59 0-6.65.72-8.19.62-1.55-.09-9.76-1.13-20.01.73-10.32 1.88-15.13 4.45-19.76 6.3-2.99 1.2-9.5 2.38-13.67 1.96-4.96-.51-10.28-1.66-20.73-.65-10.37 1.01-17.97 4.26-19.45 4.77-1.46.51-5.49 1.35-6.86 1.82-1.37.48 1.12 5.67 2.13 5.89 1.03.22 3.75.28 4.42 1.65.67 1.37 4.21 12.16 6.41 14.02 2.21 1.87 9.76 2.64 17.13 2.05 6.05-.48 14.13-3.4 15.66-5.44 1.31-1.76 2.53-4.68 3.65-9.33 1.15-4.79 1.07-7.91 2.02-8.64.95-.73 5.95-1.29 6.72-.98 1.12.44 1.9 3.48 4.31 7.76 2.35 4.18 4.32 6.65 6.05 7.99 2.02 1.55 10.59 2.16 16.54.96 7.26-1.46 14.32-4.28 15.94-6.67s2.07-13.74 2.35-15.25 3.33-1.76 4.82-2.61c1.49-.86 2.11-6.93.53-6.93v-.02Zm-63.09 22.56c-.51 3.72-1.9 6.51-3.05 8.54s-8.57 4.38-13.73 4.65c-5.69.28-11.54-.78-13.34-1.93-1.8-1.17-3.22-5.58-3.86-9.67s-.59-6.95.22-8.29c.95-1.57 8.6-2.63 16.15-3.2 7.01-.53 15.07-.16 16.95.92 1.87 1.07 1.17 5.26.65 8.97v.02Zm51.87.12c-1.41 1.6-6.44 3.89-11.99 5.16-5.04 1.17-12.83.92-14.48-.72s-3.76-3.95-5.26-7.39c-1.51-3.44-3.31-7.26-1.82-8.82 1.51-1.55 9.16-4.12 16.05-5.52 7.42-1.51 14.77-2.24 16.11-.98 1.13 1.06 1.96 3.79 2.46 7.9.5 4.1.34 8.74-1.07 10.35Z"
        style={{
          fill: '#272a3e',
        }}
      />
    </svg>
  )
}

export default RelativeEnd
